(() => {
  /* ================== CSS (kafelek + modal shell) ================== */
  const STYLE = `
html.itb-hide-amp-gift #slidecarthq .free-gifts .free-gifts-body .slick-wrapper{display:none!important}

#itb-add-50ml-card{display:flex;gap:16px;align-items:stretch;padding:12px 0;border-top:1px solid #eee}
#itb-add-50ml-card.item{margin:0}
#itb-add-50ml-card .itb-media{flex:0 0 auto;display:flex;align-items:center}
#itb-add-50ml-card .itb-media img{width:84px;height:84px;object-fit:contain}
#itb-add-50ml-card .itb-center{display:flex;flex-direction:column;flex:1 1 auto;min-width:0}
#itb-add-50ml-card .itb-title{font-weight:600;margin:0}
#itb-add-50ml-card .itb-sub{opacity:.6;margin:4px 0 0;font-size:14px;color:rgba(0,0,0,.4)}
#itb-add-50ml-card .itb-pick{
  margin-top:auto;text-decoration:none;background:#fff;border:1px solid #222;
  color:#616161;font-size:14px;padding:.5rem .75rem;border-radius:0;
  display:inline-flex;align-items:center;gap:6px;cursor:pointer
}
#itb-add-50ml-card .itb-right{margin-left:auto;display:flex;flex-direction:row;align-items:center;justify-content:center;gap: 7px;}
#itb-add-50ml-card .itb-close{background:none;border:0;color:#A1A1A1;font-size:18px;line-height:1;padding:0;visibility:hidden}
#itb-add-50ml-card .itb-price-row{display:flex;gap:.4rem;align-items:center}
#itb-add-50ml-card .itb-price{font-weight:600}
#itb-add-50ml-card .itb-price-was{color:#717171;text-decoration:line-through;font-weight:600}

/* === FULLSCREEN modal === */
#itb-add-50ml-modal{position:fixed;inset:0;display:none;z-index:2147483647;isolation:isolate}
#itb-add-50ml-modal.open{display:block}
#itb-add-50ml-modal .backdrop{position:absolute;inset:0;background:rgba(0,0,0,.35)}
#itb-add-50ml-modal .panel{
  position:relative;margin:0;background:#fff;max-width:none;border-radius:0;
  width:100vw;height:100vh;max-height:none;
  padding:clamp(12px,2vw,24px);
  padding-bottom:calc(max(16px, env(safe-area-inset-bottom)) + 30px);
  display:flex;flex-direction:column;overflow:auto;
}
#itb-add-50ml-modal .itb-modal-container{flex:1 1 auto;display:flex;flex-direction:column;min-height:0}
#itb-add-50ml-modal [data-role="section-host"]{flex:1 1 auto;min-height:0;display:flex;flex-direction:column;overflow:hidden}
#itb-add-50ml-modal [data-role="section-host"] iframe{flex:1 1 auto;width:100%;height:100%;border:0;display:block}

#itb-add-50ml-modal .close-btn{
  position:absolute;top:6px;right:6px;border:0;background:transparent;
  font-size:24px;line-height:1;cursor:pointer;color:#333
}

/* block page scroll */
html.itb-modal-open, html.itb-modal-open body{overflow:hidden}
`;

  /* ================== Konfiguracja sekcji i assetów ================== */
  const SECTION_ID     = 'itb-fragrances-grid-buyfullchoose50ml';
  const SECTION_ID_ALT = 'itb-fragrances-grid-BuyFullChoose50ml';

  const BFG_CSS_URL = "//thesaltworkscompany.com/cdn/shop/t/43/assets/BuyFullChoose50ml.css?v=34913057556545305951780057038";
  const BFG_JS_URL  = "//thesaltworkscompany.com/cdn/shop/t/43/assets/BuyFullChoose50ml.js?v=129302091055485286901780060733";

  let LAST_CART_CHANGE = 0;
  let ITB_SECTION_CACHE = null;
  let ITB_IFRAME = null;
  let ITB_ONMSG_BOUND = false;

  /* ================== Cart state cache (fetch /cart.js + invalidacja na cart events) ================== */
  let CART_CACHE = null;
  let CART_FETCH_PROMISE = null;

  async function getCart(force = false) {
    if (!force && CART_CACHE) return CART_CACHE;
    if (CART_FETCH_PROMISE) return CART_FETCH_PROMISE;
    CART_FETCH_PROMISE = fetch('/cart.js', { cache:'no-store', credentials:'same-origin' })
      .then(r => r.ok ? r.json() : { items:[] })
      .then(c => { CART_CACHE = c; return c; })
      .catch(() => ({ items:[] }))
      .finally(() => { CART_FETCH_PROMISE = null; });
    return CART_FETCH_PROMISE;
  }
  function invalidateCart(){ CART_CACHE = null; }

  function cartHasFullSize(cart){
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(it => {
      const t = (it.variant_title || it.title || '').toLowerCase();
      const opts = it.options || it.variant_options || [];
      const o1 = String(opts[0] || '').toLowerCase();
      return t.includes('100ml') || o1.includes('100ml')
          || t.includes('full size') || o1.includes('full size');
    });
  }

  function cartHas50ml(cart){
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(it => {
      const t = (it.variant_title || it.title || '').toLowerCase();
      const opts = it.options || it.variant_options || [];
      const o1 = String(opts[0] || '').toLowerCase();
      return t.includes('50ml') || o1.includes('50ml');
    });
  }

  function cartHasGiftType(cart, type){
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some(it => it && it.properties && it.properties._amp_gift === type);
  }

  /* ================== Odświeżenie SlideCart po /cart/add.js ================== */
  /*
     Cart drawer wystawia globalne SLIDECART_UPDATE(callback) który wykonuje pełen refresh.
  */
  async function refreshSlideCart(){
    await new Promise((resolve) => {
      if (typeof window.SLIDECART_UPDATE === 'function') {
        let done = false;
        try { window.SLIDECART_UPDATE(() => { done = true; resolve(); }); }
        catch(_){ resolve(); return; }
        setTimeout(() => { if (!done) resolve(); }, 800);
      } else {
        resolve();
      }
    });

    ['cart:updated','itb:cart:refresh'].forEach(ev => {
      try { document.dispatchEvent(new CustomEvent(ev, { bubbles:true, cancelable:true })); } catch(_){}
    });
  }

  /* ================== Helpers DOM/CSS/Assets ================== */
  function addStyle() {
    if (document.getElementById('itb-add-50ml-style')) return;
    const s = document.createElement('style');
    s.id = 'itb-add-50ml-style';
    s.textContent = STYLE;
    document.head.appendChild(s);
  }

  function toggleAmpGift(hide = true){
    document.documentElement.classList.toggle('itb-hide-amp-gift', !!hide);
  }

  function container() {
    return document.querySelector('#slidecarthq .free-gifts .free-gifts-body');
  }

  function ensureCssLink(href, id = 'itb-bfc50-css') {
    if (!href) return null;
    let l = document.getElementById(id);
    if (!l) {
      l = document.createElement('link');
      l.id = id;
      l.rel = 'stylesheet';
      l.href = href;
      l.disabled = true;
      document.head.appendChild(l);
    }
    return l;
  }

  function ensureJs(src, id = 'itb-bfc50-js') {
    if (!src) return Promise.resolve();
    const existing = document.getElementById(id);
    if (existing && existing.dataset.loaded === '1') return Promise.resolve();
    if (existing) {
      return new Promise(res => existing.addEventListener('load', () => res(), { once: true }));
    }
    return new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.id = id;
      s.src = src;
      s.async = true;
      s.onload = () => { s.dataset.loaded = '1'; resolve(); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  /* ================== Kafelek (zastępuje AMP slick) — async, sprawdza trigger 100ml ================== */
  async function ensureCard() {
    const host = container();
    if (!host) return;

    /*
       Reguła Mercedes (priorytet w koszyku):
         1. 50ml w koszyku → TravelSize widget (TravelSize wygrywa)
         2. tylko 100ml (brak 50ml) → BFC50 (ten widget)
         3. inaczej → nic

       BFC50 pokazuje się TYLKO gdy:
         - jest 100ml (trigger)
         - NIE MA żadnego 50ml w koszyku (priorytet TravelSize)
         - klient jeszcze nie dobrał bfc50 gift
    */
    const cart = await getCart();

    if (!cartHasFullSize(cart)) {
      const existing = document.getElementById('itb-add-50ml-card');
      if (existing) existing.remove();
      return;
    }

    // Priorytet TravelSize: jeśli w koszyku jest jakikolwiek 50ml, BFC50 znika.
    if (cartHas50ml(cart)) {
      const existing = document.getElementById('itb-add-50ml-card');
      if (existing) existing.remove();
      return;
    }

    // Klient już dobrał BFC50 gift → ukryj.
    if (cartHasGiftType(cart, 'bfc50')) {
      const existing = document.getElementById('itb-add-50ml-card');
      if (existing) existing.remove();
      return;
    }

    let el = document.getElementById('itb-add-50ml-card');
    if (el) el.classList.add('item');
    if (!el) {
      el = document.createElement('div');
      el.id = 'itb-add-50ml-card';
      el.classList.add('item');
      el.innerHTML = `
        <div class="itb-media">
          <img src="https://cdn.shopify.com/s/files/1/0653/7091/5035/files/50newSizem.jpg" alt="A second scent, for the launch"/>
        </div>
        <div class="itb-center">
          <div class="itb-title">Add a 50ml for only £50 for the launch</div>
          <div class="itb-sub">Size: 50ml Perfume</div>
                 
          <button type="button" class="itb-close" aria-hidden="true">×</button>
           <div class="itb-price-row">
           <a href="#" class="itb-pick">Pick Your Fragrance</a> 
<div class="itb-right">

          <span class="itb-price">£50</span>
          <span class="itb-price-was">£75</span>

          
          </div>
        </div>

        </div>

        `;
      el.querySelector('.itb-pick').addEventListener('click', (e) => {
        e.preventDefault();
        openModal();
      });
    }
    if (el.parentElement !== host) host.prepend(el);
  }

  /* ================== Pobieranie HTML sekcji ================== */
  async function fetchSectionHTML() {
    if (ITB_SECTION_CACHE) return ITB_SECTION_CACHE;
    const basePath = location.pathname + (location.search ? location.search.split('#')[0] : '');

    const tryId = async (id) => {
      try {
        const url1 = `${basePath}${basePath.includes('?') ? '&' : '?'}sections=${encodeURIComponent(id)}`;
        const res1 = await fetch(url1, { headers: { 'Accept': 'application/json' }});
        if (res1.ok) {
          const json = await res1.json();
          const html = json?.[id];
          if (typeof html === 'string' && html.trim()) return html;
        }
      } catch (_) {}
      const url2 = `${basePath}${basePath.includes('?') ? '&' : '?'}section_id=${encodeURIComponent(id)}`;
      const res2 = await fetch(url2, { headers: { 'Accept': 'text/html' }});
      if (res2.ok) {
        const html2 = await res2.text();
        if (html2 && html2.trim()) return html2;
      }
      return '';
    };

    let html = await tryId(SECTION_ID);
    if (!html) html = await tryId(SECTION_ID_ALT);
    if (!html) throw new Error('Section fetch failed: 404');

    ITB_SECTION_CACHE = html;
    return html;
  }

  /* ================== Pobieranie świeżych boosterów (sekcja boosters) ================== */
  async function fetchBoostersJSON(){
    const basePath = location.pathname + (location.search ? location.search.split('#')[0] : '');
    const urlA = `${basePath}${basePath.includes('?') ? '&' : '?'}sections=itb-free-gift-boosters`;
    const urlB = `${basePath}${basePath.includes('?') ? '&' : '?'}section_id=itb-free-gift-boosters`;

    const parseMaybeWrapped = (raw) => {
      if (!raw) return [];
      try {
        const x = JSON.parse(raw);
        if (Array.isArray(x)) return x;
        if (Array.isArray(x?.boosters)) return x.boosters;
      } catch(_) {}
      try {
        const doc = new DOMParser().parseFromString(raw, 'text/html');
        const host = doc.querySelector('#shopify-section-itb-free-gift-boosters');
        let txt = host ? (host.textContent || '').trim() : raw.replace(/<[^>]+>/g,'').trim();
        if (txt && (txt.startsWith('[') || txt.startsWith('{'))) {
          const x2 = JSON.parse(txt);
          if (Array.isArray(x2)) return x2;
          if (Array.isArray(x2?.boosters)) return x2.boosters;
        }
      } catch(_) {}
      return [];
    };

    const fallbackBoosters = () => {
      const src = (window.__ITB_FREE_GIFT_BFC50__ && Array.isArray(window.__ITB_FREE_GIFT_BFC50__.boosters))
        ? window.__ITB_FREE_GIFT_BFC50__.boosters : [];
      const out = src.map(b => ({ id: b.id, handle: b.handle })).filter(x => x && x.handle);
      return out;
    };

    try{
      const resA = await fetch(urlA, { headers: { 'Accept': 'application/json' }, cache:'no-store' });
      if (resA.ok) {
        const j = await resA.json();
        const raw = j?.['itb-free-gift-boosters'];
        if (raw) {
          const arr = parseMaybeWrapped(raw);
          if (arr.length) return arr;
        }
      }
    } catch(_) {}

    try{
      const resB = await fetch(urlB, { headers: { 'Accept': 'text/html' }, cache:'no-store' });
      if (resB.ok) {
        const rawHTML = await resB.text();
        const arr = parseMaybeWrapped(rawHTML);
        if (arr.length) return arr;
      }
    } catch(_) {}

    return fallbackBoosters();
  }

  /* ================== Współpraca z AMP (wybór wariantu + klik Add) ================== */
  function ampRoot(){
    return document.querySelector('#slidecarthq .free-gifts .free-gifts-body');
  }

  function findAmpGiftSelect({ variantId, productId } = {}){
    const root = ampRoot(); if (!root) return null;
    if (productId){
      const sel = root.querySelector(`#productInfoVariant${productId}`);
      if (sel) return sel;
    }
    const selects = root.querySelectorAll('.free-gifts-options select[id^="productInfoVariant"]');
    for (const s of selects){
      if ([...s.options].some(o => o.value === String(variantId))) return s;
    }
    return null;
  }

  async function ampPickGiftAndAdd({ variantId, productId }){
    // UWAGA: AMP slick pozostaje ukryty CSS-em przez cały czas — JS operuje na ukrytym elemencie.
    let sel = null, tries = 0;
    while (!sel && tries++ < 15){
      sel = findAmpGiftSelect({ variantId, productId });
      if (!sel) await new Promise(r => setTimeout(r, 120));
    }
    if (!sel) return false;

    if (sel.value !== String(variantId)) sel.value = String(variantId);
    sel.dispatchEvent(new Event('input',  { bubbles:true }));
    sel.dispatchEvent(new Event('change', { bubbles:true }));

    const item = sel.closest('[data-testid="FreeGiftsItem"]') || sel.closest('.free-gifts-item');
    const addBtn = item ? item.querySelector('.free-gifts-add-button') : null;

    await new Promise(r => setTimeout(r, 150));

    if (addBtn){
      addBtn.dispatchEvent(new MouseEvent('click', { bubbles:true, cancelable:true }));
      await new Promise(r => setTimeout(r, 350));
      return true;
    }

    return false;
  }

  /* ================== Budowa modala (shell) ================== */
  async function buildModal(){
    if (document.getElementById('itb-add-50ml-modal')) return;

    const wrap = document.createElement('div');
    wrap.id = 'itb-add-50ml-modal';
    wrap.innerHTML = `
      <div class="backdrop" data-close></div>
      <div class="panel">
        <button type="button" class="close-btn" data-close aria-label="Close">×</button>
        <div class="itb-modal-container">
          <h3 style="margin-bottom: 15px; text-align:center">Choose another favourite</h3>
          <div class="section-host" data-role="section-host"></div>
        </div>
      </div>`;
    document.body.appendChild(wrap);
    wrap.addEventListener('click', e => { if (e.target.dataset.close !== undefined) closeModal(); });
  }

  /* ================== TWARDY RESET: składanie iframa od zera ================== */
  async function rebuildIframe(){
    const shell = document.getElementById('itb-add-50ml-modal');
    if (!shell) return;
    const host = shell.querySelector('[data-role="section-host"]');
    if (!host) return;

    // wyczyść poprzedni iframe (to resetuje stan)
    host.innerHTML = '';
    ITB_IFRAME = null;

    // pobierz i sparsuj sekcję
    const html = await fetchSectionHTML();
    const tmp  = document.createElement('div');
    tmp.innerHTML = html;

    const links         = Array.from(tmp.querySelectorAll('link[rel="stylesheet"]')).map(l => l.outerHTML).join('\n');
    const scriptsSrc    = Array.from(tmp.querySelectorAll('script[src]')).map(s => s.outerHTML).join('\n');
    const scriptsInline = Array.from(tmp.querySelectorAll('script:not([src])')).map(s => s.textContent).join('\n');

    const root = tmp.querySelector('[data-grid="full"]')
               || tmp.querySelector('.itb-fragrances-grid-BuyFullChoose50ml')
               || tmp.firstElementChild;
    if (!root) throw new Error('Section root not found');

    const sectionAlreadyHasModal = !!root.querySelector('#perfumeInfo');

    // CSS tylko dla wnętrza iframa
    const iframeCSS = `
      html,body{margin:0;padding:0}
      .itb-recommended-only .element-item:not(.is-recommended){ display:none !important; }
      #itb-iframe-root .recommendationInfo{ display:none !important; }
      #itb-cta{
        position: sticky; bottom: 0; z-index: 5;
        background: linear-gradient(180deg, rgba(255,255,255,0) 0%, #fff 24%);
        padding: 8px 0 calc(env(safe-area-inset-bottom, 0px) + 10px);
        display: flex; justify-content: center;
      }
      #itb-add-to-cart-iframe{ min-width: 240px; }
      @media (max-width:480px){ #itb-add-to-cart-iframe{ width:100%; } }
    `;

    // Modal perfum — tylko w iframie (jeśli sekcja nie ma)
    const PERFUME_INFO_MODAL_HTML = `
    <div class="modal fade" id="perfumeInfo" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content rounded-0">
          <div class="modal-header">
            <h5 class="modal-title text-uppercase mb-0" data-role="title"></h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
        <div class="container-fluid">
          <div class="row">
            <div class="col-5 col-lg-6">
              <img src="" alt="image" class="img-fluid" data-role="image">
            </div>
            <div class="col-7 col-lg-6 mt-3 mt-lg-0 d-flex flex-column h-100">
                <p class="h6 text-muted mb-1" data-role="families"></p>
              <div class="sw-modal-prod-desc mb-4">
                <div class="d-flex flex-column mt-1 row-cols-1">
                  <div class="mt-2">
                    <p class="sw-p24 fw-bold mb-0">Top Notes:</p>
                    <p class="mb-0" data-role="top">top</p>
                  </div>
                  <div class="mt-2">
                    <p class="sw-p24 fw-bold mb-0">Heart Notes:</p>
                    <p class="mb-0" data-role="heart">heart</p>
                  </div>
                  <div class="mt-2">
                    <p class="sw-p24 fw-bold mb-0">Base Notes:</p>
                    <p class="mb-0" data-role="base">base</p>
                  </div>
                </div>
              </div>
              <p class="small text-muted d-none" data-role="booster-desc"></p>
            </div>
          </div>
        </div>
          </div>
        </div>
      </div>
    </div>`;

    // Bridge działa wewnątrz iframa
    const bridgeScript = `
(function(){
  function onReady(fn){
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once:true });
    else fn();
  }

  function setCTAEnabled(on){
    var cta = document.getElementById('itb-add-to-cart-iframe');
    if (!cta) return;
    if (on) cta.removeAttribute('disabled');
    else    cta.setAttribute('disabled','true');
  }

  function forceSectionRefilter(){
    var sel = document.querySelector('.filters-select');
    if (sel){
      const val = sel.value;
      sel.value = val;
      sel.dispatchEvent(new Event('change', { bubbles:true }));
    }
    try {
      var grid = document.querySelector('[data-grid="full"] .grid') || document.querySelector('.grid');
      if (!grid) return;
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.isotope){
        var $g = window.jQuery(grid);
        if ($g.data('isotope')){
          $g.isotope('updateSortData');
          $g.isotope({ sortBy:['reco','titleAZ'], sortAscending:true });
          $g.isotope('layout');
        }
      } else if (window.Isotope && window.Isotope.data){
        var iso = window.Isotope.data(grid);
        if (iso){
          iso.updateSortData();
          iso.arrange({ sortBy:['reco','titleAZ'], sortAscending:true });
        }
      }
    } catch(_){}
  }

  function pumpRefilter(times, delay){
    times = typeof times==='number' ? times : 6;
    delay = typeof delay==='number' ? delay : 140;
    let i = 0;
    (function run(){
      forceSectionRefilter();
      if (++i < times) setTimeout(run, delay);
    })();
  }

  function bindSmartSearch(){
    var input = document.getElementById('fullSearch');
    var sel   = document.querySelector('.filters-select');
    if (!input || !sel || input.__itbSmartBound) return;
    input.__itbSmartBound = true;

    var prevSet = null;
    var inSearch = false;

    var deb = (fn,t)=>{ let id; return function(){ clearTimeout(id); id=setTimeout(fn, t); }; };

    input.addEventListener('input', deb(function(){
      var q = (input.value || '').trim();
      if (q && !inSearch){
        prevSet  = sel.value;
        inSearch = true;
        if (sel.value !== '*'){
          sel.value = '*';
          sel.dispatchEvent(new Event('change', { bubbles:true }));
        } else {
          sel.dispatchEvent(new Event('change', { bubbles:true }));
        }
        pumpRefilter(4, 120);
        return;
      }

      if (!q && inSearch){
        inSearch = false;
        if (prevSet && sel.value !== prevSet){
          sel.value = prevSet;
        }
        sel.dispatchEvent(new Event('change', { bubbles:true }));
        pumpRefilter(4, 120);
        return;
      }

      pumpRefilter(2, 100);
    }, 80));
  }

  function findCardByHandle(handleLc){
    var grid = document.querySelector('[data-grid="full"] .grid') || document.querySelector('.grid');
    if (!grid) return null;
    var nodes = grid.querySelectorAll('.fragrance-item[data-handle]');
    for (var i=0; i<nodes.length; i++){
      var h = (nodes[i].getAttribute('data-handle') || '').toLowerCase();
      if (h === handleLc) return nodes[i];
    }
    return null;
  }

  function markBoosters(items){
    if (!Array.isArray(items) || !items.length) return 0;
    var count = 0;
    items.forEach(function(it){
      var handleLc = (it && it.handle ? String(it.handle) : '').toLowerCase();
      if (!handleLc) return;
      var card = findCardByHandle(handleLc);
      if (!card) return;
      if (!card.classList.contains('is-recommended')){
        card.classList.add('is-recommended');
        count++;
      }
      var badge = card.querySelector('.badge-recommended, .badge-reco');
      if (badge) badge.classList.remove('d-none');
    });
    return count;
  }

  window.addEventListener('message', function(ev){
    var msg = ev.data || {};
    if (msg.type === 'itb-append-boosters') {
      markBoosters(msg.items || []);
      pumpRefilter(8, 140);
    }
    if (msg.type === 'itb-reset') {
      document.querySelectorAll('[data-grid="full"] .fragrance-item.is-recommended')
        .forEach(function(el){
          el.classList.remove('is-recommended');
          var b = el.querySelector('.badge-recommended, .badge-reco');
          if (b) b.classList.add('d-none');
        });
      setCTAEnabled(false);
      pumpRefilter(6, 140);
    }
  }, { passive:true });

  var _selectedBtn = null, _currentVid = null, _currentPid = null;

  document.addEventListener('click', function(e){
    var cta = e.target.closest('#itb-add-to-cart-iframe');
    if (!cta) return;
    e.preventDefault();
    if (!_currentVid) return;
    try {
      parent.postMessage({
        type: 'itb-amp-select',
        variantId: Number(_currentVid),
        productId: _currentPid ? Number(_currentPid) : undefined
      }, '*');
    } catch(_){}
  });

  function setCardButtonUI(btn, selected){
    if (!btn) return;
    if (selected) {
      btn.classList.remove('btn-outline-dark');
      btn.classList.add('btn','btn-dark');
      btn.textContent = 'UNSELECT';
      btn.dataset.selected = '1';
    } else {
      btn.classList.add('btn','btn-outline-dark');
      btn.classList.remove('btn-dark');
      btn.textContent = 'SELECT';
      btn.removeAttribute('data-selected');
    }
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-role="select-product"]');
    if (!btn) return;

    var isOn = btn.dataset.selected === '1';
    if (isOn){
      setCardButtonUI(btn, false);
      _selectedBtn = null;
      _currentVid = null;
      _currentPid = null;
      setCTAEnabled(false);
      return;
    }

    if (_selectedBtn && _selectedBtn !== btn) setCardButtonUI(_selectedBtn, false);
    setCardButtonUI(btn, true);
    _selectedBtn = btn;

    var root = btn.closest('.element-item,.fragrance-item') || document.body;
    var vid =
      btn.getAttribute('data-variant-id') || btn.dataset.variantId ||
      btn.getAttribute('data-vid')        || btn.dataset.vid        ||
      root.getAttribute('data-vid')       || (root.dataset ? root.dataset.vid : '') || '';
    var pid = root.getAttribute('data-pid') || (root.dataset ? root.dataset.pid : '') || '';

    _currentVid = vid ? String(vid) : null;
    _currentPid = pid ? Number(pid) : null;

    setCTAEnabled(!!_currentVid);
  });

  onReady(function(){
    setCTAEnabled(false);
    bindSmartSearch();
    pumpRefilter(2, 150);
  });
})();
`;

    // Złożenie całego dokumentu iframa — z PEŁNYM wstrzykiem skryptów sekcji
    const srcdoc = `
<!doctype html>
<html>
<head>
<meta charset="utf-8">
<base href="${location.origin}/">
<meta name="viewport" content="width=device-width, initial-scale=1">
<style>${iframeCSS}</style>
${links}
</head>
<body>
  <div id="itb-iframe-root">
    ${root.outerHTML}
    ${sectionAlreadyHasModal ? '' : PERFUME_INFO_MODAL_HTML}
  </div>

  ${scriptsSrc}
  ${scriptsInline ? `<script>(function(){ ${scriptsInline} })();</script>` : ``}
  <script>${bridgeScript}</script>

  <div id="itb-cta"><button type="button" id="itb-add-to-cart-iframe" class="btn btn-dark" disabled>ADD TO CART</button></div>
</body>
</html>`.trim();

    const iframe = document.createElement('iframe');
    iframe.setAttribute('title','Choose another favourite');
    iframe.style.width='100%';
    iframe.style.height='80vh';
    iframe.style.border='0';
    iframe.style.display='block';
    iframe.srcdoc = srcdoc;

    host.appendChild(iframe);
    ITB_IFRAME = iframe;
  }

  /* ================== Reset stanu iframa ================== */
  function resetIframeState(){
    if (!ITB_IFRAME || !ITB_IFRAME.contentWindow) return;
    try { ITB_IFRAME.contentWindow.postMessage({ type:'itb-reset' }, '*'); } catch(_){}
  }

  /* ================== UI: zawsze ensureCard + ukryj AMP slick ================== */
  async function refreshGiftUI(){
    ensureCard();
    toggleAmpGift(true);
  }

  function sleep(ms){ return new Promise(r => setTimeout(r, ms)); }

  async function waitCartIfFreshChange(threshold = 800){
    if (Date.now() - LAST_CART_CHANGE < threshold){
      await sleep(threshold);
    }
  }

  /* ================== Open/Close modal ================== */
  async function openModal() {
    try {
      const css = ensureCssLink(BFG_CSS_URL, 'itb-bfc50-css');
      await ensureJs(BFG_JS_URL, 'itb-bfc50-js');

      await waitCartIfFreshChange(900);

      await buildModal();
      await rebuildIframe();

      if (css) css.disabled = false;
      document.getElementById('itb-add-50ml-modal').classList.add('open');
      document.documentElement.classList.add('itb-modal-open');

      await new Promise(res => {
        if (!ITB_IFRAME) return res();
        if (ITB_IFRAME.contentDocument?.readyState === 'complete') return res();
        ITB_IFRAME.addEventListener('load', () => res(), { once:true });
      });

      resetIframeState();

      const boosters = await fetchBoostersJSON();
      if (boosters && boosters.length) {
        const items = boosters
          .map(p => ({ handle: String(p.handle || '').toLowerCase() }))
          .filter(x => x.handle);
        ITB_IFRAME.contentWindow.postMessage({ type:'itb-append-boosters', items }, '*');
      }
    } catch (e) {
      console.error('[BuyFullChoose50ml] Failed to open modal', e);
    }
  }

  function closeModal() {
    const m = document.getElementById('itb-add-50ml-modal');
    if (m) {
      const host = m.querySelector('[data-role="section-host"]');
      if (host) host.innerHTML = '';
      ITB_IFRAME = null;
      m.classList.remove('open');
    }
    document.documentElement.classList.remove('itb-modal-open');
    const css = document.getElementById('itb-bfc50-css');
    if (css) css.disabled = true;
  }

  /* ================== Bezpośrednie dodanie gift z line item property ================== */
  async function addGiftDirect({ variantId }){
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: 1,
            properties: { _amp_gift: 'bfc50' }
          }]
        }),
        cache: 'no-store',
        credentials: 'same-origin'
      });
      if (!res.ok) throw new Error('add.js failed');

      invalidateCart();
      await refreshSlideCart();
      return true;
    } catch (e) {
      console.error('[BuyFullChoose50ml] addGiftDirect failed', e);
      return false;
    }
  }

  /* ================== Komunikacja z iframem (raz globalnie) ================== */
  if (!ITB_ONMSG_BOUND) {
    window.addEventListener('message', async (ev) => {
      if (!ITB_IFRAME || ev.source !== ITB_IFRAME.contentWindow) return;
      const data = ev.data || {};
      if ((data.type === 'itb-add-to-cart' || data.type === 'itb-amp-select') && data.variantId) {
        // Bezpośrednie dodanie z properties — bypass AMP. Pozwala drugiemu
        // widgetowi (AddTheTravelSize) wykryć że gift bfc50 jest aktywny i się ukryć.
        await addGiftDirect({ variantId: Number(data.variantId) });
        closeModal();
        await refreshGiftUI();
      }
    }, { passive: true });
    ITB_ONMSG_BOUND = true;
  }

  /* ================== Boot + obserwatory ================== */
  function waitForElm(sel) {
    return new Promise(resolve => {
      const e = document.querySelector(sel);
      if (e) return resolve(e);
      const mo = new MutationObserver(() => {
        const n = document.querySelector(sel);
        if (n) { mo.disconnect(); resolve(n); }
      });
      mo.observe(document.documentElement, {childList: true, subtree: true});
    });
  }

  ITB_SECTION_CACHE = null;

  const debounce = (fn, t = 60) => {
    let id; return (...a) => { clearTimeout(id); id = setTimeout(() => fn(...a), t); };
  };

  function reattach() {
    if (!document.querySelector('#slidecarthq .free-gifts .free-gifts-body')) return;
    addStyle();
    invalidateCart(); // świeży fetch /cart.js przy każdej zmianie DOM slidecart
    ensureCard();
    refreshGiftUI();
  }

  function boot() {
    addStyle();
    toggleAmpGift(true);
    ensureCard();
    refreshGiftUI();
  }

  waitForElm('#slidecarthq .free-gifts .free-gifts-body').then(() => {
    reattach();
    const target = document.querySelector('#slidecarthq .free-gifts .free-gifts-body');
    const mo = new MutationObserver(debounce(reattach, 60));
    mo.observe(target, {childList: true, subtree: true});
  });

  ['itb:cart:refresh','cart:refresh','cart:changed','cart:updated','shopify:cart:refresh','SLIDECARTHQ:updated'].forEach(evt=>{
    const handler = () => { ITB_SECTION_CACHE = null; invalidateCart(); refreshGiftUI(); };
    window.addEventListener(evt, handler, { passive:true });
    document.addEventListener(evt, handler, { passive:true });
  });

  document.addEventListener('click', (e)=>{
    if (e.target.closest('#slidecarthq .free-gifts-add-button')){
      LAST_CART_CHANGE = Date.now();
      invalidateCart();
      setTimeout(refreshGiftUI, 300);
    }
  });
  document.addEventListener('change', (e)=>{
    if (e.target.matches('#slidecarthq .free-gifts-options select[id^="productInfoVariant"]')){
      LAST_CART_CHANGE = Date.now();
      invalidateCart();
      setTimeout(refreshGiftUI, 300);
    }
  });

  (function watchDrawer(){
    const wait = (sel)=>new Promise(r=>{
      const e = document.querySelector(sel); if (e) return r(e);
      const mo = new MutationObserver(()=>{
        const n = document.querySelector(sel);
        if (n){ mo.disconnect(); r(n); }
      });
      mo.observe(document.documentElement,{childList:true,subtree:true});
    });
    wait('#slidecarthq').then(drawer=>{
      let t;
      const mo = new MutationObserver(()=>{
        clearTimeout(t);
        t = setTimeout(() => { reattach(); }, 120);
      });
      mo.observe(drawer, { childList:true, subtree:true });
    });
  })();

  document.addEventListener('shopify:section:load', reattach);
  document.addEventListener('itb:cart:refresh', reattach);

  boot();
})();
